<script setup>
import { BBadge, BLink } from 'bootstrap-vue-next';

import TableWithBusyState from '~/common/components/TableWithBusyState.vue';

defineProps({
  contributors: {
    type: Array,
    required: true,
  },
});

const fields = [
  {
    key: 'category',
    label: 'Category',
    class: 'text-center',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'mergedMRs',
    label: 'Merged MRs',
    class: 'text-end',
    tdClass: 'text-end',
  },
];

const categoryVariant = {
  SuperStar: 'warning',
  Star: 'info',
  Enthusiast: 'secondary',
};
</script>

<template>
  <TableWithBusyState
    :fields="fields"
    :items="contributors"
    show-empty
    hover
  >
    <template #cell(category)="{ value }">
      <BBadge :variant="categoryVariant[value] || 'secondary'">
        {{ value }}
      </BBadge>
    </template>
    <template #cell(name)="{ item }">
      <BLink
        v-if="item.username"
        :to="{ name: 'user', params: { userHandle: item.username } }"
      >
        {{ item.name }}
      </BLink>
      <span v-else>{{ item.name }}</span>
    </template>
  </TableWithBusyState>
</template>
